import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import withValidatedUser from './containers/withValidatedUser';
import { canRenew } from './utils/access';

// L'écran de renouvellement n'a de sens que pour qui a déjà payé et ne paie plus.
//
// ⚠️ La question n'est pas « où le serveur l'envoie-t-il », mais « a-t-il quelque chose à
// renouveler ». L'entrepreneur qui annule garde son accès jusqu'à la fin du mois payé : il
// n'est redirigé nulle part, et c'est pourtant pendant ces jours-là qu'il revient se
// réabonner.
//
// Le doublon de règle avait un coût réel. La barrière lisait ici un booléen brut, celui de
// l'utilisateur connecté : un membre d'équipe arrivait avec `false`, se faisait renvoyer
// vers « / », d'où protectedRoute le renvoyait ici — une boucle de redirections.
class ProtectedRouteRenewal extends React.Component {
  render() {
    const { component: Component, user, ...rest } = this.props;
    const allowed = canRenew(user);

    return (
      <div>
        <Route
          {...rest}
          render={(props) => (allowed ? <Component {...props} /> : <Redirect to="/" />)}
        />
      </div>
    );
  }
}

export default withValidatedUser(ProtectedRouteRenewal);
